export default "__VITE_ASSET__BQuvvi3q__"